import { ReactNode } from 'react'

export type TopBarActionsToolbarProps = {
	children: ReactNode
	className?: string
}

// Reusable wrapper for actions in the top navigation bar.
// Follows the same flex/alignment pattern as ListFilterBar so buttons and inputs
// line up consistently.
function TopBarActionsToolbar({ children, className = '' }: TopBarActionsToolbarProps) {
	return (
		<div className={`flex items-end gap-5 mr-4 ${className}`}>
			{children}
		</div>
	)
}

export default TopBarActionsToolbar
